/* eslint-disable */
import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import Content from './Content';
import { useAssumptionsAdminContext } from "./Context";

const AssumptionsAdminContainer = (props) => {
  const { assumptionCollection, initializingError, isInitializing } = useAssumptionsAdminContext();

  return (
    <DataContainer
      component={Content}
      componentProps={{
        collection: assumptionCollection,
      }}
      loading={isInitializing}
      loadingError={initializingError}
      {...props}
    />
  );
};

export default AssumptionsAdminContainer;
